import { render } from "./CoachFilter.vue?vue&type=template&id=38a3a682&scoped=true"
import script from "./CoachFilter.vue?vue&type=script&lang=js"
export * from "./CoachFilter.vue?vue&type=script&lang=js"

import "./CoachFilter.vue?vue&type=style&index=0&id=38a3a682&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a3a682"]])

export default __exports__